import React, { memo } from "react";

import MarkdownDisplay from "src/components/MarkdownDisplay";

const SchemaDescription = memo<{ description?: string }>(({ description }) => (
  <MarkdownDisplay text={description ?? ""} />
));

export default SchemaDescription;
